import { apiClient } from '@hypotenuse/common/src/utils/ApiClient'

export const apiGetIntercomSessionHmac = async (): Promise<string> => {
  return apiClient.get<string>('/intercom/hmac').then((resp) => resp.data)
}
